import Socket from '../connection/socket';
import * as SessionActions from '../stores/actions/session';
import { socketListenerDispatch } from './socket-listener-main';

export default function Users(socket: Socket) {
	socket.addListener('user-updated', (message: any) => {
		if (!message) {
			return;
		}

		socketListenerDispatch(SessionActions.userUpdated(message));
	});
	socket.addListener('users-connected', (message: any) => {
		socketListenerDispatch(SessionActions.usersList(message, socket.resetConnectedUsers));
		if (socket.resetConnectedUsers) socket.resetConnectedUsers = false;
	});
	socket.addListener('user-connected', (message: any) => {
		socketListenerDispatch(SessionActions.userConnected(message));
	});
	socket.addListener('user-disconnected', (message: any) => socketListenerDispatch(SessionActions.userDisconnected(message)));
	socket.addListener('duplicate-user-kicked', () => {
		console.log('kicked off => ');
		window.location.href = window.location.pathname.startsWith('/producer')
			? '/producer'
			: '/';
	});
	socket.addListener('duplicate-user-take-over', () => {
		window.location.reload();
	});
}